import { computed } from "vue";
import stores from "../stores";

export const configAreas= computed(() => {
    const dataSetting = stores.getStoresData().setting?.find((s: { key: string }) => s.key === 'config_areas');
    return dataSetting?.value || [];
});